import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<string>;
  public currentUser: Observable<string>;

  constructor() {
    // this.currentUserSubject = new BehaviorSubject<string>(this.services.dataStore.getData('UserID'));
    this.currentUserSubject = new BehaviorSubject<string>(localStorage.getItem('userID'));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): string {
      return this.currentUserSubject.value;
  }

  public set newUserValue(user: string) {
    this.currentUserSubject.next(user);
  }

  async logout() {
    // console.log("Auth Service logout");    
    localStorage.removeItem('userID');
    this.currentUserSubject.next(null);
    location.reload(true);
  }
} 
